<template>
  <div>
    <div class="head-box">
      <h4>新增支付</h4>
      <div class="c-flex">
        <el-input
          style="width: 330px; margin-right: 10px"
          placeholder="请输入委托方/手机号/合同编号"
          v-model="searchValue"
          clearable
          @clear="
            fpi.page = 1;
            getData();
          "
          @keyup.enter.native="
            fpi.page = 1;
            getData();
          "
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="
              fpi.page = 1;
              getData();
            "
          ></el-button>
        </el-input>
        <el-button type="primary" @click.native.prevent="newPayment(1)" size="mini">
          新增支付
        </el-button>
        <el-button type="primary" @click.native.prevent="newPayment(-1)" size="mini">
          新增退款
        </el-button>
      </div>
    </div>
    <div class="content-box">
      <div class="content-filter">
        <c-filter></c-filter>
      </div>
      <div class="content-table">
        <el-table
          ref="table"
          height="calc(100% - 50px)"
          :data="fpi.data"
          @selection-change="selectionChange"
          @select="currentSelection"
          @select-all="
            $refs.table.clearSelection();
            selectedList = [];
          "
          highlight-current-row
        >
          <!-- <el-table-column fixed="right" width="200" label="操作">
            <template slot-scope="scope">
              <el-button @click.native.prevent="newPayment(scope.row, 1)" size="mini">
                新增支付
              </el-button>
              <el-button @click.native.prevent="newPayment(scope.row, -1)" size="mini">
                新增退款
              </el-button>
            </template>
          </el-table-column> -->
          <el-table-column type="selection" fixed width="55"></el-table-column>
          <el-table-column prop="contractNum" label="合同编号" min-width="220px"></el-table-column>
          <!-- <el-table-column prop="_id" label="订单编号" min-width="120px"></el-table-column> -->
          <el-table-column
            prop="ownerName"
            fixed
            label="委托方"
            min-width="200px"
            :formatter="formatterClient"
          >
            <template slot-scope="scope">
              <el-button @click.native.prevent="handleRowClick(scope.row)" type="text">
                <!-- {{ scope.row.processState }} -->
                <!-- {{ scope.row.exts.companyName || scope.row.exts.clientname || scope.row.ownerName }} -->
                {{ formatterClient(scope.row, scope.row.ownerName) }}
              </el-button>
            </template>
          </el-table-column>
          <!-- <el-table-column
            prop="type"
            label="类型"
            min-width="120px"
            :formatter="formatterOrderType"
          ></el-table-column> -->
          <el-table-column prop="ownerPhone" label="电话" min-width="120px">
            <template slot-scope="scope">
              <!-- {{ scope.row.exts.agentPhone || scope.row.exts.telphone || scope.row.ownerPhone }} -->
              {{ formatterClientPhone(scope.row, scope.row.ownerPhone) }}
            </template>
          </el-table-column>
          <!-- <el-table-column prop="_id" label="订单编号" width="200px"></el-table-column> -->
          <!-- <el-table-column
            prop="createTime"
            label="创建时间"
            width="100px"
            show-overflow-tooltip
          ></el-table-column> -->
          <!-- <el-table-column
            prop="createUserName"
            label="创建人"
            min-width="200px"
            show-overflow-tooltip
          ></el-table-column> -->
          <!-- <el-table-column prop="tenantId" label="租户编号"></el-table-column>-->
          <!--  <el-table-column prop="contractId" label="合同编号"></el-table-column> -->
          <!--   <el-table-column prop="type" label="订单类型" :formatter="formatterOrderType"></el-table-column> -->
          <el-table-column
            prop="payState"
            label="支付状态"
            min-width="90px"
            :formatter="formatterpayState"
          ></el-table-column>
          <!-- <el-table-column
            prop="productIds"
            label="产品内容"
            :formatter="formatterProductIds"
            width="200px"
            show-overflow-tooltip
          ></el-table-column> -->
          <!-- <el-table-column
            prop="originPrice"
            label="合同金额"
            min-width="120px"
            show-overflow-tooltip
          ></el-table-column> -->
          <el-table-column
            prop="totalPrice"
            label="增减项后合同金额"
            min-width="120px"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{ osg.amountFilter(scope.row.totalPrice) }}
            </template>
          </el-table-column>
          <el-table-column
            prop="paidAmount"
            label="已收金额"
            min-width="120px"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{ osg.amountFilter(scope.row.paidAmount) }}
            </template>
          </el-table-column>
          <el-table-column
            prop="description"
            label="备注"
            min-width="100px"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="orgName"
            label="服务商名称"
            min-width="180"
            show-overflow-tooltip
          ></el-table-column>
          <!-- <template v-for="(extFiel, index) in extFields">
            <el-table-column
              min-width="180px"
              :prop="'exts.' + extFiel.name"
              show-overflow-tooltip
              :label="extFiel.nameDisp"
              :key="index"
              v-if="!extFiel.frontEndConfig || !extFiel.frontEndConfig.listHide"
            >
              <template slot-scope="scope">
                {{
                  formatterCodelabel(
                    scope.row.exts[extFiel.name],
                    extFiel.valueOption,
                    extFiel.type
                  )
                }}
              </template>
            </el-table-column>
          </template> -->
        </el-table>
        <el-pagination
          class="pagination"
          @size-change="pageSizeChange"
          @current-change="pageChange"
          :current-page="fpi.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="fpi.rows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="fpi.total"
        ></el-pagination>
      </div>
    </div>
    <el-dialog
      :title="'新增' + (payType == 1 ? '支付' : '退款')"
      v-if="payType == 1 || payType == -1"
      :visible.sync="openDetail"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      id="newPaymentsDialog"
    >
      <el-form
        :model="formData"
        :rules="rules"
        ref="formData"
        label-width="200px"
        label-position="left"
        hide-required-asterisk:true
      >
        <!-- class="c-pointer-n" -->
        <el-form-item
          :label="
            payType == 1
              ? '支付金额'
              : `退款金额 [${formData.price || 0}/${selectedList[0].paidAmount}]`
          "
          prop="price"
          :rules="{
            required: true,
            trigger: 'blur',
            message: '金额不能为空'
          }"
        >
          <el-input-number
            type="number"
            :precision="2"
            :controls="false"
            v-model="formData.price"
            :max="payType == 1 ? Infinity : selectedList[0].paidAmount"
            @input="priceChange"
            placeholder="请输入金额"
          ></el-input-number>
        </el-form-item>
        <el-form-item
          v-if="payType == 1"
          :label="(payType == 1 ? '付款' : '退款') + '人姓名'"
          prop="executor"
          :rules="{
            required: true,
            trigger: 'blur',
            message: '姓名不能为空'
          }"
        >
          <el-input v-model="formData.executor" placeholder="请输入姓名"></el-input>
        </el-form-item>
        <el-form-item
          v-if="payType == 1"
          :label="(payType == 1 ? '付款' : '退款') + '方式'"
          prop="payType"
          :rules="{
            required: true,
            trigger: 'blur',
            message: '方式不能为空'
          }"
        >
          <el-select v-model="formData.payType" placeholder="请选择方式">
            <template v-for="item in options.payType">
              <el-option
                :key="item.value"
                :label="item.label"
                :value="item.value"
                v-if="item.value != 0"
              ></el-option>
            </template>
          </el-select>
        </el-form-item>
        <el-form-item
          v-if="payType == 1"
          label="款项类型"
          prop="orderType"
          :rules="{
            required: true,
            trigger: 'blur',
            message: '款项类型不能为空'
          }"
        >
          <el-select v-model="formData.orderType" placeholder="请选择款项类型">
            <!-- <el-option
              v-for="item in options.orderPayType"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
              <span v-if="payType != -1 ? item.value != '0' : item.value == '0'">{{
                item.label
              }}</span>
            </el-option> -->
            <template v-for="item in options.orderPayType">
              <el-option
                :key="item.value"
                :label="item.label"
                :value="item.value"
                v-if="payType != -1 ? item.value != '0' : item.value == '0'"
              ></el-option>
            </template>
          </el-select>
        </el-form-item>
        <el-form-item
          v-if="payType == 1"
          :label="(payType == 1 ? '付款' : '退款') + '时间'"
          prop="payTime"
          placeholder="请选择时间"
          :rules="{
            required: true,
            trigger: 'blur',
            message: '时间不能为空'
          }"
        >
          <el-date-picker
            v-model="formData.payTime"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择日期"
          ></el-date-picker>
        </el-form-item>

        <el-form-item
          v-if="payType == 1"
          label="交易编号"
          prop="tradeNo"
          :rules="{
            required: payType != 1 || formData.payType == 4 ? false : true,
            trigger: 'blur',
            message: '交易编号不能为空'
          }"
        >
          <el-input type="number" placeholder="交易编号" v-model="formData.tradeNo"></el-input>
        </el-form-item>

        <el-form-item
          label="备注"
          prop="memo"
          :rules="{
            required: formData.orderType == 0 ? true : false,
            trigger: 'blur',
            message: '备注不能为空'
          }"
        >
          <el-input
            type="textarea"
            :placeholder="payType == 1 ? '备注' : '退款内容及原因'"
            v-model="formData.memo"
            show-word-limit
          ></el-input>
        </el-form-item>

        <el-form-item
          v-if="payType == -1"
          label="退款说明类型"
          prop="memo"
          :rules="{
            required: true,
            trigger: 'blur',
            message: '退款说明类型不能为空'
          }"
        >
          <el-select v-model="formData.refundType" placeholder="请选择退款说明类型">
            <el-option
              v-if="
                currentRefundContractType == '7' ||
                  currentRefundContractType == '11' ||
                  currentRefundContractType == '21'
              "
              key="3"
              label="退款说明"
              value="3"
            ></el-option>
            <template v-else>
              <el-option
                v-for="item in options.contractRefundType"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </template>
          </el-select>
        </el-form-item>

        <el-form-item
          v-if="payType == -1"
          label="退款说明签约类型"
          prop="memo"
          :rules="{
            required: true,
            trigger: 'blur',
            message: '退款说明签约类型不能为空'
          }"
        >
          <el-select v-model="formData.supplementTreatyType" placeholder="请选择">
            <template
              v-for="item in [
                {
                  label: '线上',
                  value: '0'
                },
                { label: '线下', value: '1' }
              ]"
            >
              <el-option :key="item.value" :label="item.label" :value="item.value"></el-option>
            </template>
          </el-select>
        </el-form-item>
      </el-form>
      <!-- <el-table :data="orderList" style="width: 100%">
        <el-table-column fixed prop="ownerName" label="委托方" width="150" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.exts.clientname || scope.row.exts.companyName }}
          </template>
        </el-table-column>
        <el-table-column
          prop="ownerPhone"
          label="委托方手机号"
          min-width="120"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            {{ scope.row.exts.agentPhone || scope.row.exts.telphone || scope.row.ownerPhone }}
          </template>
        </el-table-column>
        <el-table-column
          prop="contractNum"
          label="合同编号"
          min-width="220"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="totalPrice"
          label="总金额"
          min-width="120"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="paidAmount"
          label="已收款金额"
          min-width="160px"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="createTime"
          label="创建时间"
          min-width="150"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column label="本次支付金额" width="400">
          <template slot-scope="scope">
            <el-input
              v-model="scope.row.paymentItemsVal"
              type="number"
              placeholder="请输入金额"
              @input="paymentItemsChange($event, scope.row)"
              @blur="paymentItemsBlur(scope.row)"
            ></el-input>
          </template>
        </el-table-column>
      </el-table> -->
      <div slot="footer">
        <el-button type="primary" @click="doSave">确 定</el-button>
        <el-button @click="doInit">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapMutations } from 'vuex';
export default {
  activated() {
    window.$this = this;
  },
  name: 'newPayments',
  data() {
    return {
      name: 'order',
      fpi: {},
      searchValue: '',
      openDetail: false,
      formData: {},
      extFields: [],
      extField: {}, //特殊字段类型 如rate值为number类型,checkbox值为数组不能为空
      rules: this.$util.rules,
      options: {
        codecfg_priority: { codeId: 'PRIORITY' },
        codecfg_stage: { codeId: 'STAGE' },
        codecfg_status: { codeId: 'STATUS' },
        codecfg_productType: { codeId: 'productType' },
        codecfg_unit: { codeId: 'UNIT' },
        codecfg_auditstate: { codeId: 'auditstate' },
        codecfg_payState: { codeId: 'payState' },
        codecfg_payType: { codeId: 'payType' },
        codecfg_PaymentRecordType: { codeId: 'PaymentRecordType' },
        codecfg_orderPayType: { codeId: 'orderPayType' },
        codecfg_tradeIn: { codeId: 'tradeIn' },
        codecfg_contractRefundType: { codeId: 'contractRefundType' } //合同退款说明类型
      },
      params: {},
      orderList: [], //订单列表
      payType: null, //支付类型，1新增支付 -1新增退款
      selectedList: [], // 被勾选上的列表
      tenantId: '',
      currentRefundContractType: ''
      // currentRefundableAmount: 0 //当前可退款金额
    };
  },
  beforeCreate() {
    window.$this = this;
  },
  mounted() {
    this.doInit();
    let acount = this.osg.isJson(sessionStorage['loginAccount'])
      ? JSON.parse(sessionStorage['loginAccount'])
      : {};
    this.tenantId = acount.tenantId;
    this.osg.getFields('order', () => {
      this.osg.getFpi();
      this.getData();
    });
  },
  methods: {
    ...mapMutations(['SetCachedViews']),
    getData() {
      let params = {
        page: this.fpi.page || 1,
        rows: this.fpi.rows || 20,
        'regex:ownerName|string#or': this.searchValue,
        'regex:ownerPhone|string#or': this.searchValue,
        'regex:contractId|string#or': this.searchValue,
        'regex:contractNum|string#or': this.searchValue,
        'regex:exts.clientname|string#or': this.searchValue,
        'regex:exts.companyName|string#or': this.searchValue,
        'is:type|integer#and': '1',
        'in:state|integer#and': '1',
        'in:processState|array-integer#and': '1,2,3,-1,-2',
        'ne:exts.isAgain|string#and': '1',
        sortField: 'createTime',
        sortOrder: 'desc'
      };
      //添加过滤器参数
      $that.getParams(params);
      this.osg.setFpi(params);
      this.osg.ajax('basic/order/query.do', params, res => {
        this.fpi = res;
        this.$nextTick(() => {
          this.$refs.table.doLayout();
          this.$forceUpdate();
        });
      });
    },
    pageSizeChange(pageSize) {
      this.fpi.rows = pageSize;
      this.getData();
    },
    pageChange(currentPage) {
      this.fpi.page = currentPage;
      this.getData();
    },
    doSave() {
      if (this.osg.validate()) {
        this.$util.saveExtField(this.extFields, this.formData);
        let payList = []; //多个pay对象
        if (this.payType == 1 && this.formData.price <= 0) {
          this.osg.toast('金额需大于0 ！', 'error');
          return;
        }
        // else if (this.payType == -1 && this.formData.price >= 0) {
        //   this.osg.toast('新增退款金额需小于0 ！', 'error');
        //   return;
        // }
        if (!this.orderList.every(item => item.ownerId)) {
          this.osg.toast('查询不到委托方信息，订单内的委托方信息不存在! ！', 'error');
          return;
        }

        if (this.payType == 1) {
          // 将订单组成多个pay对象,一个订单一个pay对象
          payList = this.orderList.map(item => {
            return {
              price: this.amountToFixed(
                this.payType == 1 ? +this.formData.price : -this.formData.price
              ),
              auditstate: this.formData.auditstate,
              tradeIn: this.formData.tradeIn,
              userId: item.ownerId,
              serviceAppointmentId: item.serviceAppointmentId,
              executor: this.formData.executor,
              payType: this.formData.payType,
              orderType: this.formData.orderType,
              paymentItems: {
                [item._id]: this.amountToFixed(
                  this.payType == 1 ? +this.formData.price : -Math.abs(this.formData.price)
                )
              },
              payTime: this.formData.payTime,
              client: item.exts.companyName || item.exts.clientname || item.ownerName, //pay对象的冗余，赋值委托方
              clientPhone: item.exts.agentPhone || item.exts.telphone || item.ownerPhone, //pay对象的冗余，赋值委托方手机号
              contractNum: item.contractNum, //pay对象的冗余，赋值合同编号
              partnerName: item.orgName, //pay对象的冗余，赋值服务商名称
              tradeNo: this.formData.tradeNo, //交易编号
              memo: this.formData.memo
            };
          });
          //新增支付
          this.osg.ajax('i/pay/batchUpsert.do', { pays: JSON.stringify(payList) }, res => {
            this.doInit();
            this.getData();
            this.osg.toast('保存成功！');
          });
        } else {
          // 新增退款
          this.osg.ajax(
            'i/pay/createContractRefundpdf.do',
            {
              contractId: this.orderList[0].contractId,
              data: JSON.stringify({
                tradeIn: this.formData.supplementTreatyType,
                refundType: this.formData['refundType'],
                refundmoney: Math.abs(this.formData['price']),
                refundReason: this.formData['memo']
              })
            },
            () => {
              this.doInit();
              this.getData();
              this.osg.toast('保存成功！');
            }
          );
        }
      }
    },
    doInit() {
      this.openDetail = false;
      this.formData = { exts: {} };
      if (this.$refs.formData) this.$refs.formData.resetFields();
      this.$util.renderExtField(this.extFields, this.formData);
    },
    doNew() {
      this.doInit();
      this.openDetail = true;
    },
    // getOrder(row, callBack) {
    //   // this.formData.userId = row.contactIds.length ? row.contactIds[0] : '';
    //   // this.formData.serviceAppointmentId = row._id;
    //   // this.params = {
    //   //   page: this.fpi.page || 1,
    //   //   rows: this.fpi.rows || 20,
    //   //   sortField: 'createTime',
    //   //   sortOrder: 'desc',
    //   //   'is:serviceAppointmentId|string#and': row._id,
    //   //   'is:type|integer#and': 1,
    //   //   'is:state|integer#and': 1
    //   // };
    //   // this.osg.ajax('basic/order/query.do', this.params, res => {
    //   //   if (res && res.data && row._id) {
    //   //     res.data.map(item => (item.paymentItemsVal = ''));
    //   //     this.orderList = res.data;
    //   //   }
    //   // });
    //   this.selectedList;
    //   if (callBack) callBack();
    // },
    selectionChange(rows) {
      this.selectedList = rows;
    },
    //勾选当前行
    currentSelection(rows) {
      if (rows.length > 1) this.$refs.table.toggleRowSelection(rows.shift(), false); //单选
    },
    //金额发生改变
    priceChange() {},
    //新增支付
    newPayment(type) {
      console.log(type);
      if (!this.selectedList.length) {
        this.osg.toast('请至少选择一个！', 'warning');
        return;
      }
      if (type == 1 && this.selectedList[0].processState == -2) {
        this.osg.toast('已作废的合同不能新增支付！', 'warning');
        return;
      }
      if (type == -1) {
        // // 点击退款，
        // this.currentRefundableAmount =
        //   this.amountToFixed(this.selectedList[0].paidAmount) +
        //   this.amountToFixed(this.selectedList[0].refundMoney);
        // 没金额也能退
        // if (!this.selectedList[0].paidAmount) {
        //   this.osg.toast('没有可退款的金额！', 'warning');
        //   return;
        // }
      }
      this.currentRefundContractType =
        this.selectedList[0] && this.selectedList[0].exts && this.selectedList[0].exts.contractType;
      //新增退款
      this.formData = {
        exts: {},
        price: undefined,
        executor:
          type == -1
            ? (this.selectedList[0] &&
                this.selectedList[0].exts &&
                this.selectedList[0].exts.companyName) ||
              this.selectedList[0].exts.clientname ||
              this.selectedList[0].ownerName
            : ''
      };
      this.payType = type;
      var row = this.$util.deepCopy(row);
      this.formData.auditstate = '1';
      console.log(row);
      if (this.payType == -1) this.formData.orderType = '0';
      this.formData.tradeIn = 0;
      this.orderList = this.$util.deepCopy(
        this.selectedList.map(item => {
          item.paymentItemsVal = '';
          return item;
        })
      );
      this.formData.price = undefined;
      this.openDetail = true;
    },
    //输入支付金额改变
    paymentItemsChange(value, row) {
      if (!this.formData.paymentItems) this.formData.paymentItems = {};
      this.formData.paymentItems[row._id] = this.amountToFixed(value);
    },
    //细项金额保留两位小数
    paymentItemsBlur(row) {
      row.paymentItemsVal = +this.amountToFixed(row.paymentItemsVal);
    },
    //金额保留两位小数
    priceBlur() {
      let price = +this.amountToFixed(this.formData.price);
      this.formData.price = price ? price : undefined; //值为undefined时组件会把它转为空
    },
    // //保留两位小数
    // keepDecimals(num) {
    //   let val = +(Math.round(num * 100) / 100).toFixed(2);
    //   return val ? val : '';
    // },
    //保留两位小数的金额
    amountToFixed(money) {
      if (!money) return 0;
      let resultAmount = +(+money).toFixed(2);
      return resultAmount ? resultAmount : 0;
    },
    formatterPaymentRecordType(row) {
      if (!row) return '未知';
      return row.price > 0 ? '支付' : '退款';
    },
    //委托方特殊逻辑
    formatterClient(row, cellValue) {
      if (this.tenantId == '1340835581184723420') {
        if (row.exts.personType == '0') {
          return row.exts.clientname;
        } else {
          return row.exts.companyName;
        }
      }
      return cellValue;
    },
    formatterClientPhone(row, cellValue) {
      if (this.tenantId == '1340835581184723420') {
        if (row.exts.personType == '0') {
          return row.exts.telphone;
        } else {
          return row.exts.agentPhone;
        }
      }
      return cellValue;
    },
    //分配金额
    assignedAccounts() {},
    //计算差额
    formatDifference(row) {
      let difference = this.amountToFixed(
        this.amountToFixed(row.totalAmount) - this.amountToFixed(row.paidAmount)
      );
      return Math.abs(difference) || 0;
    },
    formatterOrderType(row, column, cellValue) {
      return this.osg.codelabel('orderType', cellValue);
    },
    formatterpayState(row, column, cellValue) {
      return this.osg.codelabel('payState', cellValue);
    },
    formatterCodelabel(cellValue, valueOption, type) {
      if (
        (type == 'cascade' && cellValue && cellValue.indexOf(',') != -1) ||
        Array.isArray(cellValue)
      ) {
        let value = Array.isArray(cellValue) ? cellValue : cellValue.split(',');
        if (Array.isArray(value)) {
          let result = '';
          for (let item of value) {
            result += this.orderCodelabel(valueOption, item) + '-';
          }
          return result.substring(0, result.length - 1); //删除最后字符
        }
      } else if (valueOption) {
        return this.osg.codelabel(valueOption, cellValue);
      } else {
        return cellValue;
      }
    },
    orderCodelabel: function(codeType, codeValue) {
      var opts = this.options[codeType];
      opts = this.cascadeFlat(opts);
      if (opts) {
        for (var i = 0; i < opts.length; i++) {
          if (codeValue == opts[i].value) return opts[i].name;
        }
      }
      if (!codeValue) {
        return codeValue;
      } else {
        return '未知';
      }
    },
    formatterProductIds(row, column, cellValue, index) {
      if (cellValue) {
        let ProductIds = JSON.parse(cellValue);
        let ProductNames = Array.isArray(ProductIds)
          ? ProductIds.map(item => item.name).join(',')
          : cellValue;
        return ProductNames;
      } else {
        return cellValue;
      }
    },
    cascadeFlat: function(source) {
      if (Array.isArray(source)) {
        let flatArr = [];
        let fn = function(source) {
          source.forEach(el => {
            flatArr.push(el);
            if (el.children && el.children.length > 0) fn(el.children);
          });
        };
        fn(source);
        return flatArr;
      } else {
        return source;
      }
    },
    handleRowClick(row) {
      // $router.push({
      //   path: `/paymentDetail/${scope.row._id}?contractNum=${scope.row.contractNum}`
      // });
      this.$router.push({
        path: `/paymentDetail/${row._id}?contractNum=${row.contractNum}`
      });
      this.SetCachedViews({
        params: row.ownerName,
        action: `/paymentDetail/${row._id}?contractNum=${row.contractNum}`
      });
    }
    // amountFilter(row, column, value) {
    //     if (!Number(value)) value = 0;
    //     return value.toLocaleString('en-us', {
    //       maximumFractionDigits: 2, // 小数位最大保留位数：0-20
    //       minimumFractionDigits: 2 // 小数位最小保留位数：0-20
    //     });
    //   },
  }
};
</script>
<style>
#app #newPaymentsDialog .el-dialog {
  width: 76% !important;
  min-width: 400px;
  max-width: 95%;
  max-height: 80vh;
  margin: 10vh auto 10vh !important;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
}
</style>
<style scoped>
input.el-input__inner {
  width: 230px;
}
</style>
